import { Routes } from '@angular/router';
import { authGuard } from '@core/guards/auth.guard';
import { roleGuard } from '@core/guards/role.guard';
import { MainLayoutComponent } from '@shared/layout/main-layout/main-layout.component';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('@features/auth/pages/login/login.component').then(m => m.LoginComponent)
  },
  {
    path: '',
    canActivate: [authGuard],
    component: MainLayoutComponent,
    children: [
      {
        path: 'dashboard',
        loadComponent: () => import('@features/dashboard/pages/dashboard/dashboard.component').then(m => m.DashboardComponent)
      },
      {
        path: 'initiatives',
        loadComponent: () =>
          import('@features/initiatives/pages/initiative-list/initiative-list.component').then(
            (m) => m.InitiativeListComponent
          ),
      },
      {
        path: 'initiatives/new',
        loadComponent: () => import('@features/initiatives/pages/initiative-new/initiative-new.component').then(m => m.InitiativeNewComponent)
      },
      {
        path: 'initiatives/:id/edit',
        loadComponent: () => import('@features/initiatives/pages/initiative-edit/initiative-edit.component').then(m => m.InitiativeEditComponent)
      },
      {
        path: 'initiatives/:id',
        loadComponent: () => import('@features/initiatives/pages/initiative-detail/initiative-detail.component').then(m => m.InitiativeDetailComponent)
      },
      {
        path: 'direction-tasks',
        canActivate: [roleGuard(['admin', 'director'])],
        loadComponent: () => import('@features/direction-tasks/pages/direction-task-list/direction-task-list.component').then(m => m.DirectionTaskListComponent)
      },
      {
        path: 'direction-tasks/new',
        canActivate: [roleGuard(['admin', 'director'])],
        loadComponent: () => import('@features/direction-tasks/pages/direction-task-new/direction-task-new.component').then(m => m.DirectionTaskNewComponent)
      },
      {
        path: 'direction-tasks/:id/edit',
        canActivate: [roleGuard(['admin', 'director'])],
        loadComponent: () => import('@features/direction-tasks/pages/direction-task-edit/direction-task-edit.component').then(m => m.DirectionTaskEditComponent)
      },
      {
        path: 'direction-tasks/:id',
        canActivate: [roleGuard(['admin', 'director'])],
        loadComponent: () => import('@features/direction-tasks/pages/direction-task-detail/direction-task-detail.component').then(m => m.DirectionTaskDetailComponent)
      },
      {
        path: 'user-management',
        canActivate: [roleGuard(['admin'])],
        loadComponent: () => import('./features/user-management/pages/user-list/user-list.component').then(m => m.UserListComponent)
      },
      {
        path: '',
        redirectTo: 'initiatives',
        pathMatch: 'full'
      }
    ]
  },
  {
    path: '**',
    redirectTo: 'initiatives'
  }
];
